// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__Vd8aq","employee-header-item":"Header_employee-header-item__K2392"};